const Client = require("../modules/ModHttpsClient")

module.exports = {
    validate(tan, accountId, projectId) {
        return new Promise((resolve) => {
            Client.get([
                {
                    key: "tan",
                    value: tan
                },
                {
                    key: "accountid",
                    value: accountId
                },
                {
                    key: "projectid",
                    value: projectId
                }
            ], {
                path: "/tan/validate"
            }).then(() => {
                resolve(true)
            }).catch(() => {
                resolve(false)
            })
        })
    },
    invalidate(tan, accountId, projectId) {
        return new Promise(resolve => {
            Client.get([
                {
                    key: "tan",
                    value: tan
                },
                {
                    key: "accountid",
                    value: accountId
                },
                {
                    key: "projectid",
                    value: projectId
                }
            ], {
                path: "/tan/invalidate"
            }).then(() => {
                resolve(true)
            }).catch(() => {
                resolve(false)
            })
        })
    }
}